var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.popVisible,
      expression: "popVisible"
    }],
    staticClass: "confirm-pop",
    on: {
      "touchmove": function touchmove($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ptc-popup"
  }, [_c('div', {
    staticClass: "popup-content"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('userSign.restoreAccountTip')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "popup-bottom"
  }, [_c('div', {
    staticClass: "btn cancel",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _vm._v(" "), _c('div', {
    staticClass: "btn ok",
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.$t('login')))])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };